import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

// Locale-aware navigation APIs. Import them from "@/i18n/navigation", which
// adds view transitions to Link and useRouter.
export const {
  Link: IntlLink,
  redirect,
  permanentRedirect,
  usePathname,
  useRouter: useIntlRouter,
  getPathname,
} = createNavigation(routing);
